import React from "react";
import { GeneratedLayer } from "./features/platform/GeneratedLayer";
import { Layout } from "./features/console/Layout";
import { IS_CONSOLE, IS_DEV } from "./utils/env";
import { Authenticator } from "@aws-amplify/ui-react";
import { theme } from "./features/console/theme";
import { MantineProvider, MantineTheme } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { emotionTransform, MantineEmotionProvider } from "@mantine/emotion";

function App() {
  return IS_CONSOLE || IS_DEV ? (
    <MantineProvider
      theme={theme}
      forceColorScheme="dark"
      stylesTransform={emotionTransform}
      cssVariablesResolver={(resolverTheme: MantineTheme) => {
        const darkVars: Record<string, string> = {
          "--mantine-color-body": "#141517",
        };
        // In v8 dark mode, light-color defaults to shade 0 (near white/washed out).
        // Override to shade 4 for vibrant colors matching v6 behavior.
        Object.keys(resolverTheme.colors).forEach((color) => {
          if (color !== "dark") {
            darkVars[`--mantine-color-${color}-light-color`] =
              resolverTheme.colors[color][4];
          }
        });
        return { variables: {}, light: {}, dark: darkVars };
      }}
    >
      <MantineEmotionProvider>
        <Notifications />
        <ModalsProvider>
          <Authenticator.Provider>
            <Layout />
          </Authenticator.Provider>
        </ModalsProvider>
      </MantineEmotionProvider>
    </MantineProvider>
  ) : (
    <GeneratedLayer />
  );
}

export default App;
